<template>
  <div>
    <user-details :userId="parseInt(userId)"></user-details>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import UserDetails from "@/containers/users/UserDetails"

export default {
  mixins: [titleMixin],
  components: { UserDetails },
  data: function() {
    return {
      title: "Mentee Profile",
      userId: this.$route.params.id
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id
      this.$store.dispatch("users/loadUser", this.userId)
    }
    next()
  }
}
</script>
